export const PHONE = "+1 737 337 7783";
export const PHONE_TEL = "+17373377783";
export const EMAIL = "info@stargroupusa.com";
export const EMAIL_SALES = "sales@stargcc.com";

const en = {
    meta: { title: "Star Group USA — Plumbing, Pumps & Electrical" },
    nav: {
        home: "Home",
        about: "About",
        products: "Products",
        career: "Career",
        contact: "Contact",
        call: "Call sales",
        menu: "Menu",
        close: "Close",
    },
    footer: {
        blurb: "Plumbing & bath accessories — pumps, plumbing and electrical appliances from Star Group USA.",
        navTitle: "Navigate",
        contactTitle: "Contact",
        hoursTitle: "Markets",
        license: "PLUMBING, PUMPS & ELECTRICAL",
        rights: "<i>Star</i> Group USA. All rights reserved.",
    },
    hero: {
        eyebrow: "PLUMBING & BATH ACCESSORIES",
        since: "PUMPS · PLUMBING · ELECTRICAL",
        lines: ["Everything", "water", "touches."],
        sub: "<i>Star</i> USA delivers a diverse range of high-quality pumps, plumbing and electrical appliances — serving clients across the USA, the Gulf and the wider MENA region. Selected from state-of-the-art manufacturing facilities under stringent quality control.",
        call: "Call sales",
        email: "Email us",
        standby: "SERVING THE USA & GLOBAL MARKETS",
        scroll: "SCROLL",
        coords: "ENGINEERED IN EVERY WAY",
    },
    marquee: [
        "PLUMBING & BATH ACCESSORIES",
        "MIXERS · SHOWERS · SHATTAFF",
        "PPR PIPES & FITTINGS",
        "VALVES · FLUSH FITTINGS",
        "PUMPS & ELECTRICAL",
    ],
    usTrade: {
        label: "FOR U.S. TRADE PROFESSIONALS",
        title: ["How we serve", "the U.S."],
        body: "Star USA brings a proven plumbing and water-products catalogue to U.S. trade professionals through dependable supply, responsive product support and partners who understand their markets.",
        cards: [
            {
                t: "Request pricing",
                d: "Ask for pricing and availability on any catalogue item.",
                cta: "Email sales",
                href: "mailto:info@stargroupusa.com?subject=Pricing request",
            },
            {
                t: "Become a distribution partner",
                d: "Bring the Star USA catalogue to your market.",
                cta: "Email partnerships",
                href: "mailto:info@stargroupusa.com?subject=Distribution partner",
            },
            {
                t: "Product support & after-sales",
                d: "Specifications, documentation and help after the sale.",
                cta: "Call customer care",
                href: "tel:+17373377783",
            },
        ],
    },
    certs: {
        label: "CERTIFIED PRODUCTS",
        line: "Selected ranges carry UPC, NSF, FSC and/or ISO certifications — certificates available on request for the products you specify.",
        badges: [
            { mark: "UPC", sub: "CERTIFIED" },
            { mark: "NSF", sub: "CERTIFIED" },
            { mark: "FSC", sub: "CERTIFIED" },
            { mark: "ISO", sub: "CERTIFIED" },
        ],
    },
    groups: {
        emptyLine: "Our full {name} range is being added to the online catalogue. Call or write for the complete specification and pricing.",
    },
    manifesto: {
        label: "WHY STAR",
        big: ["Better built.", "Better priced.", "Better serviced."],
        body: "Built to last, priced to compete, and backed by a team that still picks up the phone long after the sale. Certification documents for our ranges are available on request.",
        link: "Discover <i>Star</i> USA",
    },
    servicesSec: {
        label: "CAPABILITIES",
        title: ["WHAT WE SUPPLY"],
        link: "All products",
        cards: [
            {
                code: "01 / BATH",
                title: "Mixers, Showers & Shattaf",
                desc: "Six families — Eco, Classic, Elegant, Royal, Futura and Europa — covering every point water touches.",
            },
            {
                code: "02 / RANGE",
                title: "Pumps & Electrical Appliances",
                desc: "A diverse range of pumps, plumbing and electrical appliances for homes, businesses and projects.",
                chips: ["PUMP RANGES", "PLUMBING", "ELECTRICAL"],
            },
            {
                code: "03 / PPR",
                title: "PPR Pipes & Fittings",
                desc: "PN20 pipes from 20 to 63 mm with a full fitting program — tees, elbows, unions and valves.",
            },
            {
                code: "04 / SUPPORT",
                title: "After-Sales Network",
                desc: "Customer care from four offices — US-based head office and customer care, plus sales in Sharjah, Sohar and Doha.",
            },
        ],
    },
    productsStrip: {
        label: "FROM THE CATALOGUE",
        title: ["MACHINES & FINISHES"],
        link: "Browse products",
        items: [
            { name: "Star Elegant Basin Mixer", code: "SEBM", cat: "MIXER", chips: ["ELEGANT", "G1/2"] },
            { name: "Star Elegant Shower Head", code: "SESH5R120", cat: "SHOWER", chips: ["5 FUNCTIONS", "120 MM"] },
            { name: "Star Brass Ball Valve", code: "SBV", cat: "VALVE", chips: ["BRASS", "1/2\" – 2\""] },
        ],
    },
    stats: [
        { n: 20, suffix: "+", label: "Years of industry experience" },
        { n: 1000, suffix: "+", label: "Products across our global range" },
        { n: 5, suffix: "", label: "Years in the GCC market" },
        { n: 4, suffix: "", label: "Offices across USA & MENA" },
    ],
    cta: {
        label: "TALK TO STAR",
        big: ["Let's move", "water forward."],
        sub: "Plumbing & bath accessories, pumps and electrical appliances — one catalogue, one standard.",
        call: PHONE,
        email: EMAIL,
    },
    about: {
        eyebrow: "ABOUT STAR · PLUMBING & BATH ACCESSORIES",
        lines: ["Pumps, plumbing", "& electrical"],
        storyTitle: "From source to tap",
        storyBody:
            "<i>Star</i> USA is rooted in the pursuit of competitiveness in a technology-driven world — courage, unique talents and continuous learning. That spirit still shapes every decision we make.",
        timeline: [
            { y: "USA", t: "Head office & design centre" },
            { y: "UAE", t: "UAE sales office — Star Pumps & Pipes Trading LLC, Industrial Area 18, Sharjah" },
            { y: "OMN", t: "Oman sales office — Star Pumps Trade SPC, Alouhi Industrial Area, Sohar" },
            { y: "QAT", t: "Qatar sales office — Star Trading WLL, Hamad Port, GWC, Al Wukair" },
            { y: "GCC", t: "Qatar, Bahrain & Kuwait — with reach across the wider region" },
        ],
        valuesTitle: "HOW WE WORK",
        values: [
            {
                t: "One catalogue, every need",
                d: "From mixers and showers to PPR systems and valves — a diverse range covering every conceivable need.",
            },
            {
                t: "Two decades of expertise",
                d: "An experienced management team with over 20 years of industry experience, driving data-led decisions.",
            },
            {
                t: "Quality control first",
                d: "Every product line passes dedicated inspection before it ships.",
            },
        ],
        crewLabel: "THE NETWORK",
        crewTitle: "One <i>Star</i> USA network across MENA.",
        crewBody:
            "With a design centre, US-based customer care and sales offices in Sharjah, Sohar and Doha, the <i>Star</i> USA network keeps specification, supply and after-sales under one roof.",
        certs: ["USA", "UAE", "OMAN", "QATAR", "BAHRAIN", "KUWAIT"],
    },
    products: {
        eyebrow: "PRODUCTS & FAMILIES",
        lines: ["The", "catalogue"],
        intro:
            "Pumps, plumbing and electrical from <i>Star</i> USA — mixers, showers, shattaf, flush fittings, seat covers, PPR systems, valves, domestic and commercial pumps, water heaters, fans and more. Call to order or write to customer care.",
        callToOrder: "Call to order",
        fullSpec: "Details",
        downloadCta: "Download catalogue",
        downloadMeta: "PDF · 5 MB · 32 pages",
        drawerTitle: "PRODUCT DETAILS",
        drawerNote: "*Specifications are subject to change.",
        close: "Close",
        filterLabel: "FILTER CATALOGUE",
        filters: [
            "All",
            "Mixers",
            "Showers",
            "Shattaf",
            "Valves",
            "Flush Fittings",
            "Seat Covers",
            "PPR System",
            "Ancillaries",
        ],
        familiesLabel: "FAMILY WALL",
        familiesTitle: "Six families, one catalogue",
        families: ["ECO", "CLASSIC", "ELEGANT", "ROYAL", "FUTURA", "EUROPA"],
        brandsNote: "Don't see your model? Contact us — info@stargroupusa.com.",
        items: [
            {
                code: "SEKM2",
                name: "Star Eco Kitchen Mixer",
                cat: "MIXERS",
                series: "ECO",
                desc: "Single-lever kitchen mixer from the Eco range.",
                specs: [["Series", "Eco"], ["Type", "Kitchen mixer"], ["Connection", "G1/2"]],
            },
            {
                code: "SCBMS",
                name: "Star Classic Square Basin Mixer",
                cat: "MIXERS",
                series: "CLASSIC",
                desc: "Single-lever basin mixer, square body, from the Classic range.",
                specs: [["Series", "Classic"], ["Type", "Basin mixer"], ["Connection", "G1/2"]],
            },
            {
                code: "SEBM",
                name: "Star Elegant Basin Mixer",
                cat: "MIXERS",
                series: "ELEGANT",
                desc: "Single-lever basin mixer from the Elegant range.",
                specs: [["Series", "Elegant"], ["Type", "Basin mixer"], ["Connection", "G1/2"]],
            },
            {
                code: "SRB",
                name: "Star Royal Bath Mixer",
                cat: "MIXERS",
                series: "ROYAL",
                desc: "Bath mixer from the Royal range.",
                specs: [["Series", "Royal"], ["Type", "Bath mixer"], ["Connection", "G1/2"]],
            },
            {
                code: "SCHS3H130",
                name: "Star Classic Hand Shower — 3 Function 130 mm with Hose",
                cat: "SHOWERS",
                series: "CLASSIC",
                desc: "Three-function hand shower with 130 mm face, complete with hose.",
                specs: [["Series", "Classic"], ["Functions", "3"], ["Face", "130 mm"], ["Includes", "Hose"], ["Connection", "G1/2"]],
            },
            {
                code: "SESH5R120",
                name: "Star Elegant Shower Head — 5 Function Round 120 mm",
                cat: "SHOWERS",
                series: "ELEGANT",
                desc: "Five-function round overhead shower head, 120 mm.",
                specs: [["Series", "Elegant"], ["Functions", "5"], ["Pattern", "Round 120 mm"], ["Connection", "G1/2"]],
            },
            {
                code: "SRHS9FH",
                name: "Star Royal Hand Shower — 9 Function with Filter & Hose",
                cat: "SHOWERS",
                series: "ROYAL",
                desc: "Nine-function ABS hand shower with filter and hose.",
                specs: [["Series", "Royal"], ["Functions", "9"], ["Body", "ABS with filter"], ["Includes", "Hose"], ["Connection", "G1/2"]],
            },
            {
                code: "SCSW1",
                name: "Star Classic Shattaf Set — White",
                cat: "SHATTAFF",
                series: "CLASSIC",
                desc: "Complete shattaf set in white from the Classic range.",
                specs: [["Series", "Classic"], ["Finish", "White"], ["Type", "Shattaf set"]],
            },
            {
                code: "SFSS1",
                name: "Star Futura Shattaf Set — Square",
                cat: "SHATTAFF",
                series: "FUTURA",
                desc: "Square-pattern shattaf set from the Futura range.",
                specs: [["Series", "Futura"], ["Pattern", "Square"], ["Type", "Shattaf set"]],
            },
            {
                code: "SBV",
                name: "Star Brass Ball Valve",
                cat: "VALVES",
                series: "VALVES",
                desc: "Brass ball valve in a full size range.",
                specs: [["Material", "Brass"], ["Type", "Ball valve"], ["Sizes", "1/2\" – 2\""]],
            },
            {
                code: "SNRV",
                name: "Star Brass Non-Return Valve",
                cat: "VALVES",
                series: "VALVES",
                desc: "Brass non-return valve, with net variant available.",
                specs: [["Material", "Brass"], ["Type", "Non-return valve"], ["Sizes", "1/2\" – 2\""]],
            },
            {
                code: "SAVL12",
                name: "Star Angle Valve — Long 1/2\"",
                cat: "VALVES",
                series: "VALVES",
                desc: "Long-pattern angle valve, 1/2 inch — square, round, two-way and short variants available.",
                specs: [["Pattern", "Long"], ["Size", "1/2\""], ["Type", "Angle valve"]],
            },
            {
                code: "SDB12TP21S",
                name: "Star Double Push Cistern Fitting — 1/2\" Plastic Bottom Fill, HT 21 cm",
                cat: "FLUSH FITTINGS",
                series: "FLUSH",
                desc: "Double-push toilet cistern fitting with 1/2\" plastic bottom fill valve for one-piece tanks, 21 cm.",
                specs: [["Push", "Double"], ["Fill valve", "1/2\" plastic, bottom"], ["Tank", "1-Pc, HT 21 cm"]],
            },
            {
                code: "SSFBV12P",
                name: "Star Single Flush — 1/2\" Plastic Bottom Fill with Bracket",
                cat: "FLUSH FITTINGS",
                series: "FLUSH",
                desc: "Single-flush cistern fitting with 1/2\" plastic bottom fill valve, with bracket.",
                specs: [["Flush", "Single"], ["Fill valve", "1/2\" plastic, bottom"], ["Mount", "With bracket"]],
            },
            {
                code: "SUS11",
                name: "Star Toilet Seat Cover — U Shape Soft Close",
                cat: "SEAT COVERS",
                series: "SEATS",
                desc: "U-shape toilet seat cover with soft-close action.",
                specs: [["Shape", "U"], ["Closing", "Soft close"], ["Type", "Seat cover"]],
            },
            {
                code: "SES12",
                name: "Star Toilet Seat Cover — Egg Shape Soft Close",
                cat: "SEAT COVERS",
                series: "SEATS",
                desc: "Egg-shape toilet seat cover with soft-close action.",
                specs: [["Shape", "Egg"], ["Closing", "Soft close"], ["Type", "Seat cover"]],
            },
            {
                code: "SPPN20",
                name: "Star PPR Pipe PN20 (SDR6)",
                cat: "PPR SYSTEM",
                series: "PPR",
                desc: "PN20 polypropylene random pipe for supply lines, 20 to 63 mm.",
                specs: [["Rating", "PN20 (SDR6)"], ["Outer Ø", "20 – 63 mm"], ["Wall", "3.4 – 10.5 mm"], ["Water content", "0.137 – 1.365 l/mt"], ["Weight", "0.172 – 1.650 kg/mt"]],
            },
            {
                code: "S90E20",
                name: "Star PPR Elbow 90°",
                cat: "PPR SYSTEM",
                series: "PPR",
                desc: "PPR elbow, 90 degrees, in the full size range.",
                specs: [["Angle", "90°"], ["Sizes", "20 – 63 mm"], ["System", "PPR"]],
            },
            {
                code: "SPDUBV20",
                name: "Star PPR Double Union Ball Valve — Brass Ball",
                cat: "PPR SYSTEM",
                series: "PPR",
                desc: "PPR double union ball valve with brass ball.",
                specs: [["Ball", "Brass"], ["Sizes", "20×20 – 32×32 mm"], ["Type", "Double union valve"]],
            },
            {
                code: "SSLBT",
                name: "Star SS Bottle Trap — Long 18 cm",
                cat: "ANCILLARIES",
                series: "ANCILLARY",
                desc: "Stainless long bottle trap with zinc chrome body, 18 cm.",
                specs: [["Length", "18 cm"], ["Body", "Zinc chrome"], ["Type", "Bottle trap"]],
            },
            {
                code: "SHP60",
                name: "Star Braided Hose — 60 cm",
                cat: "ANCILLARIES",
                series: "ANCILLARY",
                desc: "Braided flexible connector, 60 cm — also in 45, 90 cm and stretchable versions.",
                specs: [["Length", "60 cm"], ["Type", "Braided hose"], ["Connection", "G1/2"]],
            },
            {
                code: "SBP10",
                name: "Star SS Pop-Up Basin Waste — 10 cm",
                cat: "ANCILLARIES",
                series: "ANCILLARY",
                desc: "Chrome pop-up basin waste with brass nut, 10 cm.",
                specs: [["Size", "10 cm"], ["Body", "SS chrome"], ["Nut", "Brass"], ["Type", "Pop-up waste"]],
            },
        ],
    },
    career: {
        eyebrow: "CAREERS AT STAR",
        lines: ["Careers at", "<i>Star</i> USA."],
        sub: "Plumbing, pumps and electrical — supplied by people. Join a team that prizes initiative, excellence and uncompromising quality.",
        introTitle: "Talented go-getters, welcome.",
        introBody:
            "<i>Star</i> USA is always looking for people who take ownership — of products, of customers and of their own growth. If you set a high bar for yourself, you will fit right in.",
        mgmtTitle: "HOW WE MANAGE",
        mgmtBody: "Our management exists to empower people to succeed: clear goals, consistent habits and regular support — then the room to do your best work.",
        lookLabel: "WHAT WE LOOK FOR",
        look: [
            {
                t: "Initiative first",
                d: "Go-getters who spot what needs doing and do it — without being asked twice.",
            },
            {
                t: "Uncompromising quality",
                d: "The same standard we demand of every product, we ask of every piece of work.",
            },
            {
                t: "Customers for the long run",
                d: "Patience, honesty and follow-through — from the first enquiry to long after the sale.",
            },
            {
                t: "Learning on the job",
                d: "New products, new markets, new skills — curiosity is part of the role.",
            },
        ],
        netLabel: "THE NETWORK",
        netTitle: "One team, four offices.",
        netBody: "From the USA head office and design centre to sales offices in Sharjah, Sohar and Doha — your work reaches customers across the USA, the Gulf and the wider region.",
        netChips: ["USA — HEAD OFFICE & DESIGN CENTRE", "UAE — SHARJAH", "OMAN — SOHAR", "QATAR — DOHA"],
        openLabel: "CURRENT OPENINGS",
        openTitle: "Two roles open right now.",
        openBody: "We are hiring across Washington, Oregon, California and Texas. Apply for a listed role below — or send your CV anyway, and we will keep it on file for the next opening.",
        openCta: "Email your CV",
        openApply: "Apply now",
        openings: [
            { title: "Sales Manager", location: "WA · OR · CA · TX", subject: "Application — Sales Manager" },
            { title: "Warehouse Manager", location: "WA · OR · CA · TX", subject: "Application — Warehouse Manager" },
        ],
        salesNote: "For roles with our sales offices outside the USA, write to",
        ctaBig: ["Ready when", "you are."],
        ctaMail: "Email your CV",
        ctaContact: "Contact page",
    },
    contact: {
        eyebrow: "CONTACT · CUSTOMER CARE",
        lines: ["Talk to", "<i>Star</i>"],
        note: "Call a sales office or write to Star Group USA — specifications, orders and support.",
        phoneLabel: "STAR GROUP USA — SALES",
        emailLabel: "EMAIL STAR GROUP USA",
        hoursTitle: "OFFICES",
        offices: [
            ["USA — HEAD OFFICE", "Head Office & Design Centre — Star USA LLC, 442 5th Avenue #1909, Manhattan, NY 10018, United States of America", "+1 (737) 337-7783", "+17373377783", "info@stargroupusa.com"],
            ["UAE — SALES OFFICE", "Star Pumps & Pipes Trading LLC, Industrial Area 18, Sharjah, United Arab Emirates", "+971 65752533", "+97165752533", "sales@stargcc.com"],
            ["OMAN — SALES OFFICE", "Star Pumps Trade SPC, Alouhi Industrial Area, Sohar, Sultanate of Oman", "+968 91990903", "+96891990903", "sales@stargcc.com"],
            ["QATAR — SALES OFFICE", "Star Trading WLL, Warehouse B1-A2-09, Hamad Port, GWC, Al Wukair, Qatar", "+974 51076716", "+97451076716", "sales@stargcc.com"],
        ],
        areaTitle: "MARKETS",
        area: [
            "Head office & customer care — USA",
            "Sales offices — UAE · Oman · Qatar",
            "Clients across the Gulf & wider region",
        ],
        yardLabel: "CATALOGUE",
        yard: "*Specifications are subject to change.",
        status: "WE MOVE WATER. WATER MOVES YOU.",
        live: "STAR",
    },
};

const es = {
    meta: { title: "Star Group USA — Plomería, Bombas y Eléctrico" },
    nav: {
        home: "Inicio",
        about: "Nosotros",
        products: "Productos",
        career: "Carrera",
        contact: "Contacto",
        call: "Llamar a ventas",
        menu: "Menú",
        close: "Cerrar",
    },
    footer: {
        blurb: "Accesorios de plomería y baño — bombas, plomería y aparatos eléctricos de Star Group USA.",
        navTitle: "Navegar",
        contactTitle: "Contacto",
        hoursTitle: "Mercados",
        license: "PLOMERÍA, BOMBAS Y ELÉCTRICO",
        rights: "<i>Star</i> Group USA. Todos los derechos reservados.",
    },
    hero: {
        eyebrow: "ACCESORIOS DE PLOMERÍA Y BAÑO",
        since: "BOMBAS · PLOMERÍA · ELÉCTRICO",
        lines: ["Todo lo que", "toca el agua."],
        sub: "<i>Star</i> USA entrega una amplia gama de bombas de alta calidad, plomería y aparatos eléctricos — al servicio de clientes en EE. UU., el Golfo y toda la región MENA. Seleccionados de instalaciones de vanguardia bajo estricto control de calidad.",
        call: "Llamar a ventas",
        email: "Escríbenos",
        standby: "AL SERVICIO DE EE. UU. Y MERCADOS GLOBALES",
        scroll: "DESPLAZA",
        coords: "DISEÑADO EN CADA DETALLE",
    },
    marquee: [
        "PLOMERÍA Y ACCESORIOS DE BAÑO",
        "MEZCLADORAS · DUCHAS · SHATTAFF",
        "TUBERÍAS Y FITTINGS PPR",
        "VÁLVULAS · RELLENO",
        "BOMBAS Y ELÉCTRICO",
    ],
    usTrade: {
        label: "PARA PROFESIONALES DE EE. UU.",
        title: ["Cómo servimos", "a EE. UU."],
        body: "Star USA pone al alcance de los profesionales de EE. UU. un catálogo probado de productos de plomería y agua, con suministro confiable, soporte receptivo y socios que entienden su mercado.",
        cards: [
            {
                t: "Solicitar precios",
                d: "Pregunta por precios y disponibilidad de cualquier artículo del catálogo.",
                cta: "Escribir a ventas",
                href: "mailto:info@stargroupusa.com?subject=Solicitud de precios",
            },
            {
                t: "Ser socio de distribución",
                d: "Lleve el catálogo de Star USA a su mercado.",
                cta: "Escribir a socios",
                href: "mailto:info@stargroupusa.com?subject=Socio de distribución",
            },
            {
                t: "Soporte y posventa",
                d: "Especificaciones, documentación y ayuda después de la venta.",
                cta: "Llamar a atención",
                href: "tel:+17373377783",
            },
        ],
    },
    certs: {
        label: "PRODUCTOS CERTIFICADOS",
        line: "Gamas seleccionadas cuentan con certificaciones UPC, NSF, FSC y/o ISO — certificados disponibles a petición para los productos que especifique.",
        badges: [
            { mark: "UPC", sub: "CERTIFICADO" },
            { mark: "NSF", sub: "CERTIFICADO" },
            { mark: "FSC", sub: "CERTIFICADO" },
            { mark: "ISO", sub: "CERTIFICADO" },
        ],
    },
    groups: {
        emptyLine: "Estamos añadiendo la gama completa de {name} al catálogo en línea. Llama o escribe para la especificación completa y precios.",
    },
    manifesto: {
        label: "POR QUÉ STAR",
        big: ["Mejor hecho.", "Mejor precio.", "Mejor servicio."],
        body: "Hecho para durar, con precios competitivos y un equipo que sigue contestando el teléfono mucho después de la venta. Los certificados de nuestras gamas están disponibles a petición.",
        link: "Descubre <i>Star</i> USA",
    },
    servicesSec: {
        label: "CAPACIDADES",
        title: ["LO QUE SUMINISTRAMOS"],
        link: "Todos los productos",
        cards: [
            {
                code: "01 / BAÑO",
                title: "Mezcladoras, Duchas y Shattaf",
                desc: "Seis familias — Eco, Classic, Elegant, Royal, Futura y Europa — cubriendo cada punto por donde pasa el agua.",
            },
            {
                code: "02 / GAMAS",
                title: "Bombas y Aparatos Eléctricos",
                desc: "Una gama diversa de bombas, plomería y aparatos eléctricos para hogares, empresas y proyectos.",
                chips: ["GAMAS DE BOMBAS", "PLOMERÍA", "ELÉCTRICO"],
            },
            {
                code: "03 / PPR",
                title: "Tuberías y Fittings PPR",
                desc: "Tuberías PN20 de 20 a 63 mm con un programa completo de fittings — tes, codos, uniones y válvulas.",
            },
            {
                code: "04 / SOPORTE",
                title: "Red de Posventa",
                desc: "Atención al cliente desde cuatro oficinas — oficina principal en EE. UU. y atención al cliente local, más ventas en Sharjah, Sohar y Doha.",
            },
        ],
    },
    productsStrip: {
        label: "DEL CATÁLOGO",
        title: ["MÁQUINAS Y ACABADOS"],
        link: "Ver productos",
        items: [
            { name: "Mezcladora de Lavabo Star Elegant", code: "SEBM", cat: "MEZCLADORA", chips: ["ELEGANT", "G1/2"] },
            { name: "Cabezal de Ducha Star Elegant", code: "SESH5R120", cat: "DUCHA", chips: ["5 FUNCIONES", "120 MM"] },
            { name: "Válvula de Bola de Latón Star", code: "SBV", cat: "VÁLVULA", chips: ["LATÓN", "1/2\" – 2\""] },
        ],
    },
    stats: [
        { n: 20, suffix: "+", label: "Años de experiencia en el sector" },
        { n: 1000, suffix: "+", label: "Productos en nuestra gama global" },
        { n: 5, suffix: "", label: "Años en el mercado del GCC" },
        { n: 4, suffix: "", label: "Oficinas en EE. UU. y MENA" },
    ],
    cta: {
        label: "HABLA CON STAR",
        big: ["Hagamos fluir", "el agua."],
        sub: "Accesorios de plomería y baño, bombas y aparatos eléctricos — un catálogo, un estándar.",
        call: PHONE,
        email: EMAIL,
    },
    about: {
        eyebrow: "SOBRE STAR · PLOMERÍA Y ACCESORIOS DE BAÑO",
        lines: ["Bombas, plomería", "y eléctrico"],
        storyTitle: "Del origen al grifo",
        storyBody:
            "<i>Star</i> USA nace de la búsqueda de competitividad en un mundo tecnológico — valentía, talento único y aprendizaje continuo. Ese espíritu sigue marcando cada decisión que tomamos.",
        timeline: [
            { y: "USA", t: "Oficina principal y centro de diseño" },
            { y: "UAE", t: "Oficina de ventas EAU — Star Pumps & Pipes Trading LLC, Área Industrial 18, Sharjah" },
            { y: "OMN", t: "Oficina de ventas Omán — Star Pumps Trade SPC, Alouhi Industrial Area, Sohar" },
            { y: "QAT", t: "Oficina de ventas Qatar — Star Trading WLL, Hamad Port, GWC, Al Wukair" },
            { y: "GCC", t: "Qatar, Baréin y Kuwait — con alcance en toda la región" },
        ],
        valuesTitle: "CÓMO TRABAJAMOS",
        values: [
            {
                t: "Un catálogo, cada necesidad",
                d: "Desde mezcladoras y duchas hasta sistemas PPR y válvulas — una gama diversa para cada necesidad.",
            },
            {
                t: "Dos décadas de experiencia",
                d: "Un equipo directivo con más de 20 años de experiencia en el sector, con decisiones basadas en datos.",
            },
            {
                t: "Primero el control de calidad",
                d: "Cada línea de producto pasa una inspección dedicada antes de su envío.",
            },
        ],
        crewLabel: "LA RED",
        crewTitle: "Una red de <i>Star</i> USA en todo MENA.",
        crewBody:
            "Con un centro de diseño, atención al cliente en EE. UU. y oficinas de ventas en Sharjah, Sohar y Doha, la red de <i>Star</i> USA mantiene especificación, suministro y posventa bajo un mismo techo.",
        certs: ["EE. UU.", "EAU", "OMÁN", "QATAR", "BARÉIN", "KUWAIT"],
    },
    products: {
        eyebrow: "PRODUCTOS Y FAMILIAS",
        lines: ["El", "catálogo"],
        intro:
            "Bombas, plomería y eléctrico de <i>Star</i> USA — mezcladoras, duchas, shattaf, mecanismos de llenado, tapas de inodoro, sistemas PPR, válvulas, bombas domésticas y comerciales, calentadores de agua, ventiladores y más. Llama para ordenar o escribe a atención al cliente.",
        callToOrder: "Llamar para ordenar",
        fullSpec: "Detalles",
        downloadCta: "Descargar catálogo",
        downloadMeta: "PDF · 5 MB · 32 páginas",
        drawerTitle: "DETALLES DEL PRODUCTO",
        drawerNote: "*Las especificaciones están sujetas a cambios.",
        close: "Cerrar",
        filterLabel: "FILTRAR CATÁLOGO",
        filters: [
            "Todos",
            "Mezcladoras",
            "Duchas",
            "Shattaf",
            "Válvulas",
            "Mecanismos de cisterna",
            "Tapas de inodoro",
            "Sistema PPR",
            "Accesorios",
        ],
        familiesLabel: "MURO DE FAMILIAS",
        familiesTitle: "Seis familias, un catálogo",
        families: ["ECO", "CLASSIC", "ELEGANT", "ROYAL", "FUTURA", "EUROPA"],
        brandsNote: "¿No encuentras tu modelo? Contáctanos — info@stargroupusa.com.",
        items: [
            {
                code: "SEKM2",
                name: "Mezcladora de Cocina Star Eco",
                cat: "MEZCLADORAS",
                series: "ECO",
                desc: "Mezcladora de cocina de palanca única de la línea Eco.",
                specs: [["Línea", "Eco"], ["Tipo", "Mezcladora de cocina"], ["Conexión", "G1/2"]],
            },
            {
                code: "SCBMS",
                name: "Mezcladora de Lavabo Star Classic Cuadrada",
                cat: "MEZCLADORAS",
                series: "CLASSIC",
                desc: "Mezcladora de lavabo de palanca única, cuerpo cuadrado, de la línea Classic.",
                specs: [["Línea", "Classic"], ["Tipo", "Mezcladora de lavabo"], ["Conexión", "G1/2"]],
            },
            {
                code: "SEBM",
                name: "Mezcladora de Lavabo Star Elegant",
                cat: "MEZCLADORAS",
                series: "ELEGANT",
                desc: "Mezcladora de lavabo de palanca única de la línea Elegant.",
                specs: [["Línea", "Elegant"], ["Tipo", "Mezcladora de lavabo"], ["Conexión", "G1/2"]],
            },
            {
                code: "SRB",
                name: "Mezcladora de Baño Star Royal",
                cat: "MEZCLADORAS",
                series: "ROYAL",
                desc: "Mezcladora de baño de la línea Royal.",
                specs: [["Línea", "Royal"], ["Tipo", "Mezcladora de baño"], ["Conexión", "G1/2"]],
            },
            {
                code: "SCHS3H130",
                name: "Ducha de Mano Star Classic — 3 Funciones 130 mm con Manguera",
                cat: "DUCHAS",
                series: "CLASSIC",
                desc: "Ducha de mano de tres funciones con plato de 130 mm, completa con manguera.",
                specs: [["Línea", "Classic"], ["Funciones", "3"], ["Plato", "130 mm"], ["Incluye", "Manguera"], ["Conexión", "G1/2"]],
            },
            {
                code: "SESH5R120",
                name: "Cabezal de Ducha Star Elegant — 5 Funciones Redondo 120 mm",
                cat: "DUCHAS",
                series: "ELEGANT",
                desc: "Cabezal de ducha empotrado redondo de cinco funciones, 120 mm.",
                specs: [["Línea", "Elegant"], ["Funciones", "5"], ["Patrón", "Redondo 120 mm"], ["Conexión", "G1/2"]],
            },
            {
                code: "SRHS9FH",
                name: "Ducha de Mano Star Royal — 9 Funciones con Filtro y Manguera",
                cat: "DUCHAS",
                series: "ROYAL",
                desc: "Ducha de mano ABS de nueve funciones con filtro y manguera.",
                specs: [["Línea", "Royal"], ["Funciones", "9"], ["Cuerpo", "ABS con filtro"], ["Incluye", "Manguera"], ["Conexión", "G1/2"]],
            },
            {
                code: "SCSW1",
                name: "Juego Shattaf Star Classic — Blanco",
                cat: "SHATTAFF",
                series: "CLASSIC",
                desc: "Juego shattaf completo en blanco de la línea Classic.",
                specs: [["Línea", "Classic"], ["Acabado", "Blanco"], ["Tipo", "Juego shattaf"]],
            },
            {
                code: "SFSS1",
                name: "Juego Shattaf Star Futura — Cuadrado",
                cat: "SHATTAFF",
                series: "FUTURA",
                desc: "Juego shattaf de patrón cuadrado de la línea Futura.",
                specs: [["Línea", "Futura"], ["Patrón", "Cuadrado"], ["Tipo", "Juego shattaf"]],
            },
            {
                code: "SBV",
                name: "Válvula de Bola de Latón Star",
                cat: "VÁLVULAS",
                series: "VÁLVULAS",
                desc: "Válvula de bola de latón en toda la gama de tamaños.",
                specs: [["Material", "Latón"], ["Tipo", "Válvula de bola"], ["Tamaños", "1/2\" – 2\""]],
            },
            {
                code: "SNRV",
                name: "Válvula de Retención de Latón Star",
                cat: "VÁLVULAS",
                series: "VÁLVULAS",
                desc: "Válvula de retención de latón, disponible con malla.",
                specs: [["Material", "Latón"], ["Tipo", "Válvula de retención"], ["Tamaños", "1/2\" – 2\""]],
            },
            {
                code: "SAVL12",
                name: "Válvula de Ángulo Star — Larga 1/2\"",
                cat: "VÁLVULAS",
                series: "VÁLVULAS",
                desc: "Válvula de ángulo de patrón largo, 1/2 pulgada — disponible en cuadrada, redonda, bidireccional y corta.",
                specs: [["Patrón", "Larga"], ["Tamaño", "1/2\""], ["Tipo", "Válvula de ángulo"]],
            },
            {
                code: "SDB12TP21S",
                name: "Mecanismo de Cisterna Star Doble Push — 1/2\" Plástico Relleno Inferior, HT 21 cm",
                cat: "FITTINGS DE RELLENO",
                series: "RELLENO",
                desc: "Mecanismo de cisterna de doble push con válvula de relleno inferior de 1/2\" plástico para tanques de una pieza, 21 cm.",
                specs: [["Push", "Doble"], ["Válvula de relleno", "1/2\" plástico, inferior"], ["Tanque", "1 pieza, HT 21 cm"]],
            },
            {
                code: "SSFBV12P",
                name: "Star Relleno Simple — 1/2\" Plástico Inferior con Soporte",
                cat: "FITTINGS DE RELLENO",
                series: "RELLENO",
                desc: "Mecanismo de cisterna de relleno simple con válvula inferior de 1/2\" plástico, con soporte.",
                specs: [["Relleno", "Simple"], ["Válvula", "1/2\" plástico, inferior"], ["Montaje", "Con soporte"]],
            },
            {
                code: "SUS11",
                name: "Tapa de Inodoro Star — U con Cierre Suave",
                cat: "TAPAS DE INODORO",
                series: "TAPAS",
                desc: "Tapa de inodoro en forma de U con cierre suave.",
                specs: [["Forma", "U"], ["Cierre", "Suave"], ["Tipo", "Tapa de inodoro"]],
            },
            {
                code: "SES12",
                name: "Tapa de Inodoro Star — Huevo con Cierre Suave",
                cat: "TAPAS DE INODORO",
                series: "TAPAS",
                desc: "Tapa de inodoro en forma de huevo con cierre suave.",
                specs: [["Forma", "Huevo"], ["Cierre", "Suave"], ["Tipo", "Tapa de inodoro"]],
            },
            {
                code: "SPPN20",
                name: "Tubería PPR Star PN20 (SDR6)",
                cat: "SISTEMA PPR",
                series: "PPR",
                desc: "Tubería de polipropileno random PN20 para líneas de suministro, de 20 a 63 mm.",
                specs: [["Presión", "PN20 (SDR6)"], ["Ø Exterior", "20 – 63 mm"], ["Pared", "3.4 – 10.5 mm"], ["Contenido de agua", "0.137 – 1.365 l/mt"], ["Peso", "0.172 – 1.650 kg/mt"]],
            },
            {
                code: "S90E20",
                name: "Codo PPR Star 90°",
                cat: "SISTEMA PPR",
                series: "PPR",
                desc: "Codo PPR de 90 grados en toda la gama de tamaños.",
                specs: [["Ángulo", "90°"], ["Tamaños", "20 – 63 mm"], ["Sistema", "PPR"]],
            },
            {
                code: "SPDUBV20",
                name: "Válvula PPR Star de Doble Unión — Bola de Latón",
                cat: "SISTEMA PPR",
                series: "PPR",
                desc: "Válvula PPR de doble unión con bola de latón.",
                specs: [["Bola", "Latón"], ["Tamaños", "20×20 – 32×32 mm"], ["Tipo", "Válvula de doble unión"]],
            },
            {
                code: "SSLBT",
                name: "Trampa de Botello Star — Larga 18 cm",
                cat: "ACCESORIOS",
                series: "ACCESORIO",
                desc: "Trampa de botello larga de acero inoxidable con cuerpo cromado de zinc, 18 cm.",
                specs: [["Longitud", "18 cm"], ["Cuerpo", "Zinc cromado"], ["Tipo", "Trampa de botello"]],
            },
            {
                code: "SHP60",
                name: "Manguera Trenzada Star — 60 cm",
                cat: "ACCESORIOS",
                series: "ACCESORIO",
                desc: "Conector flexible trenzado, 60 cm — también en 45, 90 cm y versión extensible.",
                specs: [["Longitud", "60 cm"], ["Tipo", "Manguera trenzada"], ["Conexión", "G1/2"]],
            },
            {
                code: "SBP10",
                name: "Desagüe Pop-Up Star — 10 cm",
                cat: "ACCESORIOS",
                series: "ACCESORIO",
                desc: "Desagüe pop-up de lavabo cromado con tuerca de latón, 10 cm.",
                specs: [["Tamaño", "10 cm"], ["Cuerpo", "Acero cromado"], ["Tuerca", "Latón"], ["Tipo", "Desagüe pop-up"]],
            },
        ],
    },
    career: {
        eyebrow: "CARRERAS EN STAR",
        lines: ["Carreras en", "<i>Star</i> USA."],
        sub: "Plomería, bombas y eléctrico — suministrado por personas. Únete a un equipo que valora la iniciativa, la excelencia y una calidad sin concesiones.",
        introTitle: "Bienvenidos los talentos con iniciativa.",
        introBody:
            "<i>Star</i> USA siempre busca personas que asuman el mando — de los productos, de los clientes y de su propio crecimiento. Si te exiges un nivel alto, encajarás aquí.",
        mgmtTitle: "CÓMO DIRIGIMOS",
        mgmtBody: "Nuestra dirección existe para que cada persona pueda triunfar: metas claras, hábitos constantes y apoyo regular — y luego la libertad de dar lo mejor.",
        lookLabel: "QUÉ BUSCAMOS",
        look: [
            {
                t: "Iniciativa primero",
                d: "Personas con iniciativa que ven lo que hay que hacer y lo hacen — sin que se lo pidan dos veces.",
            },
            {
                t: "Calidad sin concesiones",
                d: "El mismo estándar que exigimos a cada producto lo pedimos a cada trabajo.",
            },
            {
                t: "Clientes para siempre",
                d: "Paciencia, honestidad y seguimiento — desde la primera consulta hasta mucho después de la venta.",
            },
            {
                t: "Aprender en el camino",
                d: "Productos nuevos, mercados nuevos, habilidades nuevas — la curiosidad es parte del puesto.",
            },
        ],
        netLabel: "LA RED",
        netTitle: "Un equipo, cuatro oficinas.",
        netBody: "Desde la oficina principal y el centro de diseño en EE. UU. hasta las oficinas de ventas en Sharjah, Sohar y Doha — tu trabajo llega a clientes de EE. UU., el Golfo y toda la región.",
        netChips: ["EE. UU. — OFICINA PRINCIPAL Y CENTRO DE DISEÑO", "EAU — SHARJAH", "OMÁN — SOHAR", "QATAR — DOHA"],
        openLabel: "VACANTES ACTUALES",
        openTitle: "Dos vacantes abiertas ahora.",
        openBody: "Estamos contratando en Washington, Oregon, California y Texas. Postúlate a una de las vacantes de abajo — o envía tu CV igualmente; lo guardaremos para la próxima apertura.",
        openCta: "Enviar CV por correo",
        openApply: "Aplicar ahora",
        openings: [
            { title: "Gerente de Ventas", location: "WA · OR · CA · TX", subject: "Application — Sales Manager" },
            { title: "Gerente de Almacén", location: "WA · OR · CA · TX", subject: "Application — Warehouse Manager" },
        ],
        salesNote: "Para puestos en nuestras oficinas de ventas fuera de EE. UU., escribe a",
        ctaBig: ["Listos cuando", "lo estés."],
        ctaMail: "Enviar CV por correo",
        ctaContact: "Página de contacto",
    },
    contact: {
        eyebrow: "CONTACTO · ATENCIÓN AL CLIENTE",
        lines: ["Habla", "con <i>Star</i>"],
        note: "Llama a una oficina de ventas o escribe a Star Group USA — especificaciones, pedidos y soporte.",
        phoneLabel: "STAR GROUP USA — VENTAS",
        emailLabel: "CORREO STAR GROUP USA",
        hoursTitle: "OFICINAS",
        offices: [
            ["EE. UU. — OFICINA PRINCIPAL", "Oficina principal y centro de diseño — Star USA LLC, 442 5th Avenue #1909, Manhattan, NY 10018, Estados Unidos", "+1 (737) 337-7783", "+17373377783", "info@stargroupusa.com"],
            ["EAU — OFICINA DE VENTAS", "Star Pumps & Pipes Trading LLC, Área Industrial 18, Sharjah, Emiratos Árabes Unidos", "+971 65752533", "+97165752533", "sales@stargcc.com"],
            ["OMÁN — OFICINA DE VENTAS", "Star Pumps Trade SPC, Alouhi Industrial Area, Sohar, Sultanato de Omán", "+968 91990903", "+96891990903", "sales@stargcc.com"],
            ["QATAR — OFICINA DE VENTAS", "Star Trading WLL, Warehouse B1-A2-09, Hamad Port, GWC, Al Wukair, Qatar", "+974 51076716", "+97451076716", "sales@stargcc.com"],
        ],
        areaTitle: "MERCADOS",
        area: [
            "Oficina principal y atención al cliente — EE. UU.",
            "Oficinas de ventas — EAU · Omán · Qatar",
            "Clientes en el Golfo y toda la región",
        ],
        yardLabel: "CATÁLOGO",
        yard: "*Las especificaciones están sujetas a cambios.",
        status: "NOSOTROS MOVEMOS EL AGUA. EL AGUA TE MUEVE.",
        live: "STAR",
    },
};

export const CONTENT = { en, es };
